import React, { Component, createRef } from 'react';
import { Button, Typography, Box, Grid } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { getCompanyName } from '../utils/OpenCampground_Database_Calls'
import '../CSS/Transactions.css';
import CampgroundCalendar from './Site';

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

class Parent extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.state = {
            companyName: '',
        };
    }

    async componentDidMount() {
    }

    render() {

        return (
                <CampgroundCalendar onClose={this.props.onClose}/>
        );
    }
}

export default Parent;